var ineligibleIDs = [
    '992',
    '255',
    '256',
    '271',
    '272',
    '958',
    '963',
    '985',
    '961'
];
export var isIneligibleTransactionCode = function (transactionCode) {
    return ineligibleIDs.includes(transactionCode);
};
export var isMissingRequiredData = function (transactionEligiblePayload) {
    var accountId = transactionEligiblePayload.accountId, operationId = transactionEligiblePayload.operationId, transactionAmount = transactionEligiblePayload.transactionAmount, transactionDate = transactionEligiblePayload.transactionDate, transactionId = transactionEligiblePayload.transactionId;
    return (!accountId ||
        !operationId ||
        !transactionAmount ||
        !transactionDate ||
        !transactionId);
};
//# sourceMappingURL=helpers.js.map